// Returns a stable list of {value, label} options for the Default Locations
// platform dropdowns. The list is sourced from
// Models.Candidate::getAllSourceTypesAndPlatforms (coffee/models/candidate.coffee:274)
// so it stays in sync with the Newsroom sidebar "Sources" element.
//
// The 'social_platform' parent source-type is excluded — its child platforms
// (e.g. TikTok, Mastodon) are flattened into the same list by the helper, so
// keeping the parent would produce a duplicate, non-selectable option.
//
// In environments where the global Backbone Models registry is unavailable
// (e.g. component unit tests), an empty array is returned and the consumer
// renders an empty dropdown — tests typically mock the Select anyway.
const getPlatformOptions = () => {
  const Candidate = typeof Models !== 'undefined' && Models.Candidate;
  if (!Candidate || !Candidate.prototype || !Candidate.prototype.getAllSourceTypesAndPlatforms) {
    return [];
  }
  // The helper calls this.getAllSourceTypes() and this.getAllPlatforms(),
  // which are also on the prototype — so the prototype itself is the right `this`.
  const all = Candidate.prototype.getAllSourceTypesAndPlatforms.call(Candidate.prototype);
  return all
    .filter((entry) => entry.value !== 'social_platform')
    .map((entry) => ({ value: entry.value, label: entry.label }));
};

export default getPlatformOptions;
